(function () {
  var fields = ['title', 'product_type', 'tag', 'vendor', 'variants.title', 'variants.sku', 'variants.barcode'];
  function scoped(query) {
    return query.indexOf('(title:') === 0 && query.indexOf(' OR product_type:') !== -1;
  }
  function compile(query) {
    query = String(query || '').trim();
    if (!query || scoped(query)) return query;
    var terms = query.match(/"[^"]+"|\S+/g) || [];
    return terms.map(function (term) {
      // Treat user input as text rather than letting it select the description field.
      var quoted = term[0] === '"' && term[term.length - 1] === '"';
      var value = (quoted ? term.slice(1, -1) : term).replace(/[\\:()"*]/g, '\\$&');
      if (quoted) value = '"' + value + '"';
      return '(' + fields.map(function (field) { return field + ':' + value; }).join(' OR ') + ')';
    }).join(' AND ');
  }
  function url(query, base) {
    var target = new URL(base || ((window.Shopify && Shopify.routes.root) || '/') + 'search', location.origin);
    target.searchParams.set('q', compile(query));
    target.searchParams.set('type', 'product');
    return target.pathname + target.search;
  }
  window.auroreSearchQuery = { compile: compile, url: url };
  function displayQuery(query) {
    return query.split(') AND (').map(function (group) {
      return group.split(' OR product_type:')[0].replace(/^\(?title:/, '').replace(/\\([\\:()"*])/g, '$1');
    }).join(' ');
  }
  // Apply the same scope to old bookmarks and links to unscoped search URLs.
  if (/\/search\/?$/.test(location.pathname)) {
    var current = new URL(location.href);
    var query = current.searchParams.get('q') || '';
    if (query && !scoped(query)) location.replace(url(query, current.href));
    if (scoped(query)) {
      var display = displayQuery(query);
      document.title = document.title.split(query).join(display);
      document.querySelectorAll('input[name="q"]').forEach(function (input) {
        if (scoped(input.value)) input.value = displayQuery(input.value);
      });
    }
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var target = new URL(form.action, location.href);
    if (!/\/search\/?$/.test(target.pathname)) return;
    var data = new FormData(form);
    if (!data.has('q')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    target.search = new URLSearchParams(data).toString();
    location.assign(url(data.get('q'), target.href));
  }, true);
})();
